import React, { useContext, useState } from 'react';
import { describeRequest, toPowerShell } from '../api/request';
import { RouteTableContext } from '../RouteTableContext';
import { IconTerminal } from '../icons';

// The "PowerShell" button: shows the command that makes the same call as the page, and the call itself. Nothing the page does is hidden.
//   route   the whole route, for example 'v3/accounts'
//   params  the query parameters the page sends (the same object it gives to the API client)
//   body    the JSON document a PUT sends; the command takes it from the pipeline
export default function ShowCommand({ route, params, method = 'GET', body, label = 'PowerShell', disabled = false }) {
  const { routes, loaded } = useContext(RouteTableContext);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const entry = routes.find((r) => r.route === route && r.method === method);
  const call = describeRequest(route, params, method, body);
  const command = entry ? toPowerShell(entry, params, body) : null;

  const copy = () => {
    try {
      Promise.resolve(navigator.clipboard.writeText(command)).then(() => setCopied(true), () => setCopied(false));
    } catch (ex) { setCopied(false); }                                    // no clipboard: the text is on screen to select
  };

  return (
    <div className="showcmd">
      <button type="button" className="btn btn-sm" aria-expanded={open} disabled={disabled} onClick={() => { setOpen((v) => !v); setCopied(false); }}>
        <IconTerminal />{label}
      </button>
      {open && !disabled && (
        <div className="card showcmd-panel" role="region" aria-label="PowerShell">
          <div className="showcmd-label">Command</div>
          <pre className="code-block" data-testid="showcmd-command">{command || (loaded ? 'No command is listed for this route.' : 'Loading...')}</pre>
          <div className="showcmd-label">The call it makes</div>
          <pre className="code-block" data-testid="showcmd-call">{`${call.method} ${call.url}`}</pre>
          <div className="showcmd-foot">
            <span>Add -Verbose to print the request{method === 'PUT' ? ', -WhatIf to check it without saving' : ''}{method === 'POST' ? ', -WhatIf to judge without keeping anything' : ''}.</span>
            {command && <button type="button" className="btn btn-sm" onClick={copy}>{copied ? 'Copied' : 'Copy'}</button>}
          </div>
        </div>
      )}
    </div>
  );
}
